import { Box, SxProps, Theme } from '@mui/material'
import React from 'react'

interface ErrorBannerProps {
  visible?: boolean
  children?: React.ReactNode
  sx?: SxProps<Theme>
}

/**
 * This component is responsible for displaying an error message to the service user
 * when they are accessing a deleted installation/system
 *
 */
const ErrorBanner: React.FC<ErrorBannerProps> = ({ visible, children, sx = [] }) => {
  if (!visible) return null

  const baseSx: SxProps<Theme> = theme => ({
    backgroundColor: theme.shape.errorBanner?.background,
    borderRadius: 1,
    textAlign: 'center',
    padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
  })

  return <Box sx={[baseSx, ...(Array.isArray(sx) ? sx : [sx])]}>{children}</Box>
}

export default ErrorBanner
